module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('app-loading') : _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center mt-10"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n          Actividades (" + _vm._s(_vm.activities.length) + ")\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        return _vm.toggleModalMessage(true)
      }
    }
  }, [_vm._v("\n          Mensaje Inxapp\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "to": "/admin/points"
    }
  }, [_vm._v("\n          Ver Puntos\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "to": "/admin/activities/create"
    }
  }, [_vm._v("\n          Crear Actividad\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("NOMBRE / DESCRIPCION")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ARCHIVOS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("TIPO / ESTADO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("FECHAS VIGENCIA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activities), function(activity) {
    return _c('tr', {
      key: ("activity-" + (activity.slug)),
      staticClass: "intro-x"
    }, [_c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-900 font-bold text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(_vm._f("limit")(activity.name)) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-500 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                  " + _vm._s(_vm._f("limit")(activity.description)) + "\n                ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                Imagen: "), _c('br'), _vm._v(" "), (activity.image) ? _c('a', {
      staticClass: "text-blue-600 underline",
      attrs: {
        "href": activity.image,
        "target": "_blank"
      }
    }, [_vm._v("\n                  Ver imagen\n                ")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                Material de estudio: "), _c('br'), _vm._v(" "), (activity.study_information) ? _c('a', {
      staticClass: "text-blue-600 underline",
      attrs: {
        "href": activity.study_information,
        "target": "_blank"
      }
    }, [_vm._v("\n                  Ver archivo\n                ")]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-900 font-bold text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(activity.type) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                  " + _vm._s(activity.status_name) + "\n                ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                Fecha inicial: "), _c('br'), _vm._v("\n                " + _vm._s(activity.start_date) + " "), _c('br'), _c('br'), _vm._v("\n                Fecha final: "), _c('br'), _vm._v("\n                " + _vm._s(activity.end_date) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('button', {
      staticClass: "flex items-center block py-1 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md text-xs",
      on: {
        "click": function($event) {
          return _vm.editActivity(activity)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Editar actividad\n                ")], 1)]), _vm._v(" "), (activity.type !== 'Extra') ? _c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('router-link', {
      staticClass: "flex items-center block py-1 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md text-xs",
      attrs: {
        "to": ("/admin/activities/" + (activity.slug) + "/questions")
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "table",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Editar preguntas\n                ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('router-link', {
      staticClass: "flex items-center block py-1 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md text-xs",
      attrs: {
        "to": ("/admin/activities/" + (activity.slug))
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "clipboard",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Detalle\n                ")], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('router-link', {
      staticClass: "flex items-center block py-1 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md text-xs",
      attrs: {
        "to": ("/admin/activities/" + (activity.slug) + "/participations")
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "eye",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Participaciones\n                ")], 1)], 1)])])
  }), 0)])]), _vm._v(" "), (_vm.show_activity_model) ? _c('ModalEditActivity', {
    attrs: {
      "current_activity": _vm.current_activity
    },
    on: {
      "close": _vm.closeEditActivity
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modalMessage) ? _c('ModalMessage', {
    on: {
      "close": function($event) {
        return _vm.toggleModalMessage(false)
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0234793e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/activity/ListActivity.vue
// module id = 402
// module chunks = 1